// @ts-nocheck
import { UnixTime } from "@pdfking/tfunc"
import fire_event from "@pdfking/workflow/utils/fire_event"
import { get_translations } from "@pdfking/workflow/utils/make_translations"
import translate from "@pdfking/workflow/utils/render_string"
import virtual from "@pdfking/workflow/vue/3/virtual"
import user_get from "../constants/user_get"
import on from "../dom/on"
import clear_ajax_cache from "../navigation/clear_ajax_cache"
import messages from "./messages"

export default virtual({
  computed: {
    is_just_staff() {
      return !!(this.id && this.is_staff)
    },
    is_just_user() {
      return !!(this.id && !this.is_staff)
    },
  },
  data: () => user_get(),
  methods: {
    dispatch_event(initial = true) {
      if (this.id) {
        fire_event(document, "user_login", { initial })

        const current = UnixTime()

        if (current - this.signup_time <= 5) {
          fire_event(document, "user_signup", { initial })
        }
      } else {
        fire_event(document, "user_logout", { initial })
      }
    },
  },
  mounted() {
    on("site_init", null, this.dispatch_event)
  },
  watch: {
    has_discount: () => clear_ajax_cache(),
    id(id) {
      if (id) {
        get_translations("actions").then(actions =>
          messages.add(
            translate(actions.LOGIN, {
              user: this.email || this.name || this.id,
            })
          )
        )
      }

      this.dispatch_event(false)

      clear_ajax_cache()
    },
  },
})
